import React, { useEffect, useState } from "react";

interface popUpProps {
    text: string
    onChange: (e: string) => void
    warning: boolean
    disabled: boolean
    maxLength: number
}

function TextExtend(props: popUpProps) {
    const [text, setText] = useState(props.text)
    const [expanded, setExpanded] = useState(false)
    const warning = props.warning
    const maxLen = props.maxLength
    useEffect(() => {
        setText(props.text)
    }, [props.text])

    return (
        <>
            {expanded ?
                <div className="expandableMore">
                    {/*r-18-lint-cn*/}
                    {/*eslint-disable-next-line*/}
                    <textarea value={text ?? ""} onChange={(e) => (props.onChange(e.target.value), setText(e.target.value))} disabled={props.disabled} maxLength={maxLen} /><span className="expand material-icons" onClick={() => setExpanded(false)}>unfold_less</span>
                    {warning ? <span className="cellWarning material-icons">warning</span> : null}
                </div> :
                <div className="expandableLess">
                    {/*r-18-lint-cn*/}
                    {/*eslint-disable-next-line*/}
                    <input type="text" value={text ?? ""} onChange={(e) => (props.onChange(e.target.value), setText(e.target.value))} disabled={props.disabled} maxLength={maxLen} /><span className="material-icons" onClick={() => setExpanded(true)} >unfold_more</span>
                    {warning ? <span className="cellWarning material-icons">warning</span> : null}
                </div>
            }


        </>
    )
}

export default TextExtend